export const data = {
    header: {
        title: "Toufiq Alahi",
        description: "MERN Stack developer & Computer engineer",
    },
    about: {
        description: `Hello!
        I am Toufiq Alahi, born in Bangladesh and grew up in Jashore City. I graduated from Shahjalal University of Science and Technology (SUST) with a bachelor's degree in Computer Science and Engineering. I'm a big devotee of Agile methodologies and web development technologies such as HTML, CSS, Javascript, Typescript, ReactJS, NextJS, NodeJS, ExpressJS, MongoDB, Python, SQL, Redux, Daisy UI, Styled-Components, and Bootstrap. I have experience with version control software like Git and cloud services such as Github, Firebase, Google Cloud, and Mongo Atlas.`,
        grades: [
            {
                title: "Build amazing sites with HTML, CSS and JS",
                url: "1.jpg",
            },
            {
                title: "Git & Github essentials",
                url: "2.jpg",
            },
            {
                title: "Automation",
                url: "3.jpg",
            },
            {
                title: "Python 3 master course",
                url: "4.jpg",
            },
            {
                title: "Python 3 desde cero",
                url: "5.jpg",
            },
            {
                title: "React desde cero",
                url: "6.jpg",
            },
            {
                title: "Scientific computing with python",
                url: "7.png",
            },
            {
                title: "Scrum master",
                url: "8.jpg",
            },
            {
                title: "Mongo DB for JS developers",
                url: "9.jpg",
            },
            {
                title: "Android mobile development",
                url: "10.png",
            },
        ],
    },
    resume: {
        experience: [
            {
                company: "Complete Web Development Course with Jhankar Mahbub",
                position: "Student",
                startDate: " ",
                endDate: "1st June 2022",
                description:
                    "I have successfully completed the MERN Stack course, where I have mastered nemours  technologies such as HTML, CSS, Bootstrap, JavaScript, ReactJS, NextJS, Redux, MongoDB",
            },
        ],
        education: [
            {
                school: "Shahjalal University of Science and Technology (SUST)",
                degree: "Computer Science and Engineering (B.Sc)",
                graduated: "February 2022",
                description:
                    "During my bachelor's in Computer Science and Engineering, it all started with Fundamentals of Programming. I have learned a variety of programming languages. I also learned about Data Structures & Algorithms, Object-Oriented Programming, Operating Systems, Database Management Systems, Computer Networks, Compiler Design, Theory of Computation, Software Engineering, Artificial Intelligence etcetera. Apart from these, I have learned a lot about mathematics.",
            },
        ],
        grades: [
            {
                school: "Universidad de Antioquia",
                degree: "Android development",
                graduated: "2021",
            },
            {
                school: "FreeCodeCamp Academy",
                degree: "Computing Science with Python",
                graduated: "2021",
            },
            {
                school: "University Mongo",
                degree: "MongoDB for Javascript developers",
                graduated: "2021",
            },
            {
                school: "AWS Educate",
                degree: "Cloud Computing 101",
                graduated: "2021",
            },
            {
                school: "Udemy",
                degree: "React from scratch",
                graduated: "2021",
            },
            {
                school: "Udemy",
                degree: "Python 3 Master Course",
                graduated: "2021",
            },
            {
                school: "Udemy",
                degree: "Scrum Master",
                graduated: "2021",
            },
            {
                school: "Amigos Code",
                degree: "Git & GitHub Essencials",
                graduated: "2021",
            },
        ],
        skills: [

            {
                name: "React JS",
                level: "90%",
            },
            {
                name: "JavaScript",
                level: "85%",
            },
            {
                name: "TailWind CSS",
                level: "90%",
            },
            {
                name: "Node JS",
                level: "80%",
            },
            {
                name: "MongoDB",
                level: "70%",
            },
            {
                name: "Express JS",
                level: "70%",
            },
            {
                name: "Next JS",
                level: "75%",
            },
            {
                name: "TypeScript",
                level: "70%",
            },


            {
                name: "MySQL",
                level: "60%",
            },

        ],
        otherSkills: [
            {
                name: "Microsoft Office",
                level: "95%",
            },
            {
                name: "Firebase",
                level: "80%",
            },
            {
                name: "Daisy UI",
                level: "90%",
            },
            {
                name: "Adobe Premiere Pro",
                level: "85%",
            },
            {
                name: "Adobe Audition",
                level: "80%",
            },
        ],
        languages: [
            {
                name: "English",
                level: "Fluent",
                skills: [
                    { listening: "80%" },
                    { speaking: "75%" },
                    { writing: "80%" },
                    { reading: "85%" },
                ],
            },
        ],
    },
    portfolio: {
        projects: [
            {
                title: "Motel Website",
                image: "pp (1).jpg",
                description:
                    "The Butterfinger Motel is a Motel website. I built it with React, React-Router, and TailwindCss. The different Routes are: Home, Reviews, Dashboard, Blogs, and About. Switching different route does not reloads the pages.",
                url: "https://butterfinger-motel-by-toufiq.netlify.app/",
            },
            {
                title: "Perfume Website",
                image: "pp (2).jpg",
                description:
                    "The Perfumance Inventory website consists of Client-side built with React, React-Router, and React-Bootstrap. The backend is built with MongoDB and ExpressJS. Firebase was used for authentication and hosting.",
                url: "https://assignment-11-b1240.web.app/",
            },
            {
                title: "Immigration Consultancy Website",
                image: "pp (3).jpg",
                description:
                    "The Immigration and Visa consultancy is a website for an individual who provides such consultancy in that particular areas. The main Authentication system were build with firebase containing Email/Password, Facebook, Google Sign In. ",
                url: "https://butterfinger-immigration.web.app/",
            },
            {
                title: "Movie decider",
                image: "pp (4).jpg",
                description:
                    "The Movie decider landing page was my first React project, was made using React, vanilla CSS and TMDB api. I used React, and React-Bootstrap for the frontend. Design. The users may select few movies and then one particular movie would be selected randomly from the TMDB api.",
                url: "https://confused-viewer-toufiq.netlify.app/",
            },
            {
                title: "Smart Phone Website",
                image: "pp (5).jpg",
                description:
                    "This Smartphone landing page were built using React and Bootstrap. The website is a responsive website that works on all devices. The home page contains a search bar where a user can search for a particular phones/brands and view the detailed info from the API. ",

                url: "https://toufiq-mr-phone.netlify.app/",
            },
            {
                title: "Financial Calculator",
                image: "pp (6).jpg",
                description:
                    "This front-end based Banking page works as a financial calculator. The user can enter the amount of their income and expenditure  and the calculator will calculate the total expenses. And by putting a % value of savings it can calculate the final remaining amount of their income.",
                url: "https://butterfinger-banking.netlify.app/",
            },
        ],
        currentWork: [
            {
                title: "My Own Social Network",
                technologies: [],
                description: "",
                image: "",
            },
            {
                title: "FullStack project",
                technologies: [],
                description: "",
                image: "",
            },
        ],
    },
};
